export default __webpack_public_path__ + "static/media/desktop-trend-legend.4a7aedcd.png";